export default "__VITE_ASSET__DHD8YpaR__"